// Auto-generated - do not edit
export const RELEASE = '0b2d251cc7f694ecd605c72dacde2b96258a6a1d';
